import React from "react";
import PropTypes from 'prop-types';

import MoreButton from '../utils/more-button';
import Spinner from '../../_utils/spinner';
import UrlThumbnail from '../thumbnails/url-thumbnail';

const streamPhotos = props => {
  if (!props.photos.length) {
    return <Spinner />;
  }

  return (
    <div id="streamDiv" style={{ height: props.height, overflow: 'auto' }}>
      <div className="scroll-box">
        {
          props.photos.map((photo, i) => (
            <UrlThumbnail
              file={photo}
              selected={props.isSelected(photo)}
              key={`stream-${photo.id}-${i}`}
              onSelect={props.onSelect}
              onUnSelect={props.onUnSelect}
              withOrientation
            />
          ))
        }
        {
          !!props.hasMoreButton &&
          <MoreButton
            id="load-more-stream"
            onMoreButtonClick={props.onMoreButtonClick}
          />
        }
      </div>
    </div>
  );
};

streamPhotos.propTypes = {
  hasMoreButton: PropTypes.bool,
  height: PropTypes.number.isRequired,
  isSelected: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onUnSelect: PropTypes.func.isRequired,
  photos: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
};

export default streamPhotos;
